import "./AppFooter.css";
import React from "react";
import footerIcon from "@safecv/assets/Images/Powered_BRIDGEi2i.png";

function AppFooter() {
  return (
    <div className="fixed-bottom">
      <div className="footer">
        <div className="footer-icon">
          <img src={footerIcon} className="" alt="logo" />
        </div>
        <div className="version">
          <div>SAFEBuilt V12.0.0</div>
        </div>
      </div>
    </div>
  );
}

export default AppFooter;
